export default __webpack_public_path__ + "static/media/Rune Stone of Shared Bloodshed.bdfc4383.jpg";